import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const YesIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M18.5858 6.58582L20 8.00003L9.65685 18.3137L8.24264 16.8995L18.5858 6.58582ZM5.41421 11.2427L9.65685 15.4853L8.24264 16.8995L4 12.6569L5.41421 11.2427Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
YesIcon.displayName = 'YesIcon'
export default YesIcon
